import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {PriceRobotCompetitor} from "./price-robot-competitor";
import {PriceRobotUrl} from "./price-robot-url";
import {PriceRobotFilter} from "./price-robot-filter";
import {environment} from "../../environments/environment";
import {AuthService, BaseService} from "@hassel-it/angular-common";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PriceRobotCompetitorService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    index(filter: PriceRobotFilter = new PriceRobotFilter()): Observable<CompetitorResponse> {
        this.reloadHeaders();

        let myParams = new HttpParams();
        myParams = myParams.append('pending', filter.pending);
        myParams = myParams.append('error', filter.withErrors);
        return this.http.get<CompetitorResponse>(environment.apiBase + '/api/tenfour-crawler/competitors', {
            headers: this.httpHeaders,
            params: myParams
        });
    }

    view(id: string) {
        this.reloadHeaders();

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/competitors/' + id, {
            headers: this.httpHeaders
        })
    }

    getUrls(id, page, filter: any) {
        this.reloadHeaders();
        let myParams = new HttpParams();
        myParams = myParams.append('page', page);
        if (filter && filter.approved) {
            myParams = myParams.append('isApproved', 1);
        }
        if (filter && filter.pending) {
            myParams = myParams.append('isApproved', 0);
        }
        if (filter && filter.error) {
            myParams = myParams.append('isError', 1);
        }if (filter && filter.urlId) {
            myParams = myParams.append('urlId', filter.urlId);
        }

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/competitors/' + id + '/crawler-urls', {
            headers: this.httpHeaders,
            params: myParams
        })
    }

    addCrawlerUrl(competitorid: string, url: PriceRobotUrl) {
        this.reloadHeaders();
        return this.http.post(environment.apiBase + '/api/tenfour-crawler/competitors/' + competitorid + '/crawler-urls/', url, {
            headers: this.httpHeaders
        })

    }

    editCrawlerUrl(competitorid: string, url: PriceRobotUrl) {
        this.reloadHeaders();

        return this.http.patch(environment.apiBase + '/api/tenfour-crawler/competitors/' + competitorid + '/crawler-urls/' + url.id, {url: url}, {
            headers: this.httpHeaders
        })
    }

    deleteCrawlerUrl(competitorid: string, url: PriceRobotUrl) {
        this.reloadHeaders();

        return this.http.delete(environment.apiBase + '/api/tenfour-crawler/competitors/' + competitorid + '/crawler-urls/' + url.id, {
            headers: this.httpHeaders
        })
    }

    editCompetitor(competitor: PriceRobotCompetitor) {
        this.reloadHeaders();

        return this.http.put(environment.apiBase + '/api/tenfour-crawler/competitors/' + competitor.id, {
            id: competitor.id,
            name: competitor.name,
            process_class: competitor.process_class,
            preference_class: competitor.preference_class,
            url: competitor.url
        }, {
            headers: this.httpHeaders
        })
    }
}

export interface CompetitorResponse {
    competitors: PriceRobotCompetitor[];
}
